import { useState } from "react";
import { Globe, Copy, ExternalLink, Loader2 } from "lucide-react";
import { toast } from "sonner";
import api from "../../lib/api";

export function PublicPacketToggle({ page, onChange }) {
  const [busy, setBusy] = useState(false);
  if (!page) return null;

  const toggle = async () => {
    setBusy(true);
    try {
      const { data } = await api.put("/account/carrier-packet", { public_enabled: !page.enabled });
      onChange?.(data.public_page);
      toast.success(data.public_page.enabled ? "Carrier page is live — brokers can download your packet any time" : "Carrier page hidden");
    } catch (err) { toast.error(err?.response?.data?.detail || "Couldn't update"); }
    finally { setBusy(false); }
  };

  const copy = async () => {
    try { await navigator.clipboard.writeText(page.url); toast.success("Carrier page link copied"); }
    catch { toast.error("Couldn't copy — long-press the link instead"); }
  };

  return (
    <div className="mt-4 pt-3 border-t border-white/[0.06]" data-testid="packet-public-page">
      <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5">
        <label className="flex items-center gap-2 text-sm cursor-pointer">
          <input type="checkbox" checked={page.enabled} onChange={toggle} disabled={busy} className="accent-[#FF5A1F]" data-testid="packet-public-toggle" />
          <Globe className={`w-3.5 h-3.5 ${page.enabled ? "text-emerald-300" : "text-white/40"}`} />
          <span className="text-white/85 font-semibold">Public carrier page</span>
          {busy && <Loader2 className="w-3 h-3 animate-spin text-white/40" />}
        </label>
        {page.enabled && page.url && (
          <span className="flex items-center gap-2 text-xs min-w-0">
            <a href={page.url} target="_blank" rel="noreferrer" className="text-[#FF5A1F] font-mono truncate max-w-[260px] hover:underline" data-testid="packet-public-url">{page.url.replace(/^https?:\/\//, "")}</a>
            <button type="button" onClick={copy} className="text-white/50 hover:text-white" aria-label="Copy link" data-testid="packet-public-copy"><Copy className="w-3.5 h-3.5" /></button>
            <a href={page.url} target="_blank" rel="noreferrer" className="text-white/50 hover:text-white" aria-label="Open" data-testid="packet-public-open"><ExternalLink className="w-3.5 h-3.5" /></a>
            {page.downloads > 0 && <span className="text-sky-200" data-testid="packet-public-downloads">downloaded ×{page.downloads}</span>}
          </span>
        )}
      </div>
      <p className="text-[11px] text-white/40 mt-1 leading-relaxed">
        {page.enabled
          ? "Brokers see your legal name, MC status, a BrokerCheck badge and a Download-all button — the link is added to every packet email."
          : "Off by default. Turn on to give brokers a branded page with your MC status, BrokerCheck badge and a Download-all button."}
      </p>
    </div>
  );
}
